import apolloClient from "../services/apolloSetup";
import { GET_ARTICLE, GET_ARTICLE_DATA, GET_ARTICLE_PROP_VALUE, GET_ARTICLE_PROPS } from "../operations/queries/articles";
import {
  CREATE_ARTICLE_PROP_VALUE_,
  CREATE_ARTICLE_,
  DELETE_ARTICLE,
  UPDATE_ARTICLE,
  UPDATE_ARTICLE_PROP_VALUE,
} from "../operations/mutations/articles";

import { figurenames } from "../constants";

const useArticles = () => {
  //Get all data with one article
  //Figure data
  //Selected figure
  const getOneArticle = async (id) => {
    const response = await apolloClient.query({
      query: GET_ARTICLE(id),
    });
    if (response && response.data && response.data.article) {
      const art = response.data.article;

      const artData = await getArticleData(id);
      if (!artData) return null;
      let article_type = art.id_article_type.name.toLowerCase();

      let figure = {
        name: article_type,
      };

      //Get atributtes for this figure (radius, lenght, etc)
      let values = {};
      figurenames[article_type].forEach((data) => {
        let prop = artData.find((el) => el.tag.trim() === data.key);
        values[data.key] = prop && prop.value && parseInt(prop.value);
      });

      artData.forEach((el) => {
        if (!values[el.tag.trim()]) {
          art[el.tag.trim()] = parseInt(el.value);
        }
      });

      figure.values = values;
      art.figure = figure;
      art.selected_figure = article_type;
      return art;
    } else {
      return null;
    }
  };

  //Get data from one article
  const getArticleData = async (id) => {
    const response = await apolloClient.query({
      query: GET_ARTICLE_DATA(id),
    });
    return response && response.data && response.data.articlePropertiesValues;
  };

  //Get articles types list
  const getArticleTypes = async () => {
    const response = await apolloClient.query({
      query: GET_ARTICLE_PROPS,
    });
    return response && response.data && response.data.articleTypes;
  };

  //Get value from one property
  const getArticlePropValue = async (id, tag) => {
    const response = await apolloClient.query({
      query: GET_ARTICLE_PROP_VALUE(id, tag),
    });
    return response && response.data && response.data.articlePropertyValue;
  };

  //Create one article property value
  const newPropPromise = (id_article, tag, value) => {
    return new Promise((resolve, reject) => {
      apolloClient
        .mutate({
          mutation: CREATE_ARTICLE_PROP_VALUE_,
          variables: { id_article: id_article, tag: tag.toString(), value: value.toString() },
        })
        .then(() => resolve(1))
        .catch(() => resolve(0));
    });
  };

  //Edit property value from one article
  const editPropPromise = (id_article, tag, value) => {
    return new Promise((resolve, reject) => {
      apolloClient
        .mutate({
          mutation: UPDATE_ARTICLE_PROP_VALUE,
          variables: { id_article: id_article, tag: tag, value: value },
        })
        .then(() => resolve(1))
        .catch(() => resolve(0));
    });
  };

  //Create a new article
  const setArticle = async (article, id_entity) => {
    const new_article = await apolloClient.mutate({
      variables: {
        name: article.name,
        is_prototype: article.is_prototype,
        date: article.date,
        id_article_type: article.id_article_type,
        id_entity: id_entity,
      },
      mutation: CREATE_ARTICLE_,
    });

    if (new_article && new_article.data && new_article.data.createArticle) {
      const newPropers = await Promise.all(
        article.properties.map((prop) => newPropPromise(new_article.data.createArticle, prop.tag, prop.value))
      );

      if (newPropers.reduce((a, b) => a + b, 0) === article.properties.length) return new_article.data.createArticle;
      else return false;
    } else {
      return false;
    }
  };

  //Update one article
  const updateArticle = async (article) => {
    const edit_article = await apolloClient.mutate({
      variables: { id_article: article.id_article, name: article.name, is_prototype: article.is_prototype },
      mutation: UPDATE_ARTICLE,
    });

    if (edit_article && edit_article.data && edit_article.data.updateArticle) {
      const updatePropers = await Promise.all(article.properties.map((prop) => editPropPromise(article.id_article, prop.tag, prop.value)));

      if (updatePropers.reduce((a, b) => a + b, 0) === article.properties.length) return true;
      else return false;
    } else {
      return false;
    }
  };

  //Delete one article
  const deleteArticle = async (id_article, id_entity) => {
    return apolloClient
      .mutate({
        variables: { id_article: id_article, id_entity: id_entity },
        mutation: DELETE_ARTICLE,
      })
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  };

  return {
    articleData: getArticleData,
    articleProp: getArticlePropValue,
    setArticle: setArticle,
    deleteArticle: deleteArticle,
    articleTypes: getArticleTypes,
    getOneArticle,
    updateArticle,
  };
};

export default useArticles;
